import api from "./api"

const ACTIVE_ACCOUNT_KEY = "@oktto:webPushActiveAccount"

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4)
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/")
    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)

    for (let i = 0; i < rawData.length; i++) {
        outputArray[i] = rawData.charCodeAt(i)
    }

    return outputArray
}

function isWebPushSupported() {
    return Boolean(
        "serviceWorker" in navigator &&
        "PushManager" in window &&
        "Notification" in window
    )
}

async function getServiceWorkerRegistration() {
    const registration = await navigator.serviceWorker.register("/service-worker.js")
    await navigator.serviceWorker.ready
    return registration
}

async function getPublicKey() {
    const response = await api.get("/webpush/public-key")
    return response?.data?.data?.publicKey
}

async function registerWebPushSubscription(account_id) {
    if (!account_id || !isWebPushSupported()) {
        return false
    }

    const permission = await Notification.requestPermission()
    if (permission !== "granted") {
        return false
    }

    const registration = await getServiceWorkerRegistration()
    const publicKey = await getPublicKey()
    if (!publicKey) {
        return false
    }

    const existingSubscription = await registration.pushManager.getSubscription()
    const subscription = existingSubscription || await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey)
    })

    await api.post("/webpush/subscription", {
        account_id,
        subscription: subscription.toJSON()
    })

    localStorage.setItem(ACTIVE_ACCOUNT_KEY, account_id)
    return true
}

async function unregisterWebPushSubscription() {
    if (!isWebPushSupported()) {
        return false
    }

    const registration = await navigator.serviceWorker.getRegistration("/")
    const subscription = await registration?.pushManager?.getSubscription()
    if (!subscription) {
        localStorage.removeItem(ACTIVE_ACCOUNT_KEY)
        return false
    }

    await api.post("/webpush/unsubscribe", {
        endpoint: subscription.endpoint
    }).catch(() => { })

    await subscription.unsubscribe().catch(() => { })
    localStorage.removeItem(ACTIVE_ACCOUNT_KEY)
    return true
}

async function syncWebPushSubscription(account_id, enabled) {
    if (enabled) {
        return registerWebPushSubscription(account_id)
    }

    return unregisterWebPushSubscription()
}

export { isWebPushSupported, registerWebPushSubscription, unregisterWebPushSubscription, syncWebPushSubscription }
